import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const IMAGES = ["/assets/inspo-1.png", "/assets/inspo-2.png", "/assets/inspo-3.png"];

export const InspirationCarousel = () => {
  const [i, setI] = useState(0);
  const n = IMAGES.length;

  useEffect(() => {
    IMAGES.forEach((src) => { const img = new Image(); img.src = src; });
  }, []);

  const prev = () => setI((v) => (v - 1 + n) % n);
  const next = () => setI((v) => (v + 1) % n);

  return (
    <div data-testid="inspiration-carousel">
      <p className="text-sm font-semibold text-[#AEBFD8] mb-3 leading-relaxed">
        Need some inspiration? Here are some example styles — pick one that catches your eye and mention it below.
      </p>

      <div className="relative rounded-xl overflow-hidden border border-[rgba(65,176,255,0.45)] bg-[#06152D]/80">
        <img src={IMAGES[i]} alt={`Example website style ${i + 1}`} className="w-full block select-none" />

        <button type="button" onClick={prev} aria-label="Previous example" data-testid="carousel-prev"
          className="absolute left-3 top-1/2 -translate-y-1/2 grid place-items-center w-10 h-10 rounded-full bg-[#020B1D]/70 border border-[rgba(65,176,255,0.55)] text-[#F7FAFF] backdrop-blur-md hover:bg-[#020B1D]/90 hover:border-[#39D5FF] hover:text-[#39D5FF] transition">
          <ChevronLeft size={20} />
        </button>
        <button type="button" onClick={next} aria-label="Next example" data-testid="carousel-next"
          className="absolute right-3 top-1/2 -translate-y-1/2 grid place-items-center w-10 h-10 rounded-full bg-[#020B1D]/70 border border-[rgba(65,176,255,0.55)] text-[#F7FAFF] backdrop-blur-md hover:bg-[#020B1D]/90 hover:border-[#39D5FF] hover:text-[#39D5FF] transition">
          <ChevronRight size={20} />
        </button>
      </div>

      <p className="mt-2 text-center text-xs font-semibold text-[#7F92AE]" data-testid="carousel-counter">
        {i + 1}/{n}
      </p>
    </div>
  );
};
